import { api } from "@/api/api";
import {
  PurchaseStatus,
  type StandardPaymentProvider,
} from "@/app/payments/types";
import type { CreateOrderOutputDto } from "@/types/codegen";

import { constructOrderApiParams } from "./utils";

const provider = "SANDBOX";

export const sandboxPaymentProvider: StandardPaymentProvider = {
  initiatePayment: async ({ onSuccess, onFailure, ...params }) => {
    const { apiUrl, apiParams } = constructOrderApiParams(params);
    const response = await api.post<CreateOrderOutputDto>(apiUrl, {
      ...apiParams,
      provider,
    });

    const orderId = response?.data?.data?.sandboxSession?.orderId;

    if (!orderId) {
      throw new Error("Invalid response from API: Missing orderId");
    }

    return {
      orderId,
      status: PurchaseStatus.SUCCESSFUL,
    };
  },
};
